import React, { useState } from 'react';
import ReactSelect from 'react-select';
import { SelectHandle } from '../../../schema/interface';
import CustomSelect from '../CustomSelect';
import { SelectStyles } from '../DropDown.Style';

const DropDownSingle = ({
    handleSelect,
    options,
    selectedOptions,
    min,
    required,
    isOtherOptionEnabled,
    otherOptionValue,
    handleBlur,
    noAccess
}: SelectHandle) => {
    const [isChanging, setIsChanging] = useState(false);
    const Select = (props: any) => {
        return (
            <CustomSelect
                {...props}
                SelectComponent={ReactSelect}
                isChanging={isChanging}
                isDisabled={noAccess}
            />
        );
    };
    return (
        <Select
            styles={SelectStyles as any}
            value={selectedOptions}
            isClearable={!min || !required}
            isMulti={false}
            options={options}
            getOptionLabel={(val: string[][]) => val[1]}
            getOptionValue={(val: string[][]) => val[0]}
            required={
                !!min ||
                (required && (!isOtherOptionEnabled || (isOtherOptionEnabled && !otherOptionValue)))
            }
            onChange={(items: string[][]) => {
                handleSelect(items?.[0]);
                setIsChanging(true);
            }}
            onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                handleBlur(e);
                setIsChanging(false);
            }}
        />
    );
};

export default DropDownSingle;
